/** Null status means evaluation is required */
export const workerRequirementEvaluationStatus = ['pass', 'fail'] as const
export type WorkerRequirementEvaluationStatus =
  (typeof workerRequirementEvaluationStatus)[number]

export type Evaluation = {
  /** Worker requirements with verification type 'assessment' */
  workerRequirementId: number
  /** Agent requirement assessment status */
  agentStatus: WorkerRequirementEvaluationStatus | null
  /** Admin requirement assessment status */
  adminStatus: WorkerRequirementEvaluationStatus | null
}

export type Interview = {
  externalCandidateId: string
  calls: {
    transcriptUrl: string
    audioUrl: string
  }[]
}

export type AssessmentRequirement = {
  workerRequirementId: number
  name: string
  question: string
}
